exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".cart.cart-mini{max-height:80%;height:80%}.cart-mini .cart-product{clear:both;padding:5px 0;overflow:hidden;border-bottom:1px solid #efefef}.cart-mini .cart-product .product-description,.cart-mini .cart-product .product-thumbnail{float:left}.cart-mini .cart-product .product-description{width:158px;padding-left:12px;overflow:hidden;text-overflow:ellipsis}.cart-mini .cart-product .product-actions{float:right}.cart-mini .total{font-weight:700;padding:12px 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./~/postcss-loader!./src/components/Cart/CartMini.scss
// module id = 735
// module chunks = 0